import React from 'react';
import {
  Lightbulb,
  Rocket,
  Target,
  AlertTriangle,
  Check,
  Info,
  Star,
  Brain,
  BookOpen,
  BarChart3,
  Globe,
  Users,
  TrendingUp,
  Clock,
} from 'lucide-react';
import { IconType } from '../types/content-components.types.js';

interface ComponentIconProps {
  icon: IconType;
  className?: string;
}

export const ComponentIcon: React.FC<ComponentIconProps> = ({ icon, className = 'w-5 h-5' }) => {
  const iconMap: Record<IconType, React.ReactNode> = {
    lightbulb: <Lightbulb className={className} />,
    rocket: <Rocket className={className} />,
    target: <Target className={className} />,
    warning: <AlertTriangle className={className} />,
    check: <Check className={className} />,
    info: <Info className={className} />,
    star: <Star className={className} />,
    brain: <Brain className={className} />,
    book: <BookOpen className={className} />,
    chart: <BarChart3 className={className} />,
    globe: <Globe className={className} />,
    users: <Users className={className} />,
    trending: <TrendingUp className={className} />,
    clock: <Clock className={className} />,
  };

  return <>{iconMap[icon] || <Info className={className} />}</>;
};

